
    .responsive3208187990__root .TagsReadOnly605524272__root {
        gap: 8px 4px;
    }

    .responsive3208187990__root .TagsReadOnly605524272__liReadOnly {
        border-color: #cfd1dc;
        padding: 3px 8px;
    }


/* st-namespace-reference="../../../../src/atoms/SelectionTags/TagsReadOnly.responsive.st.css" */